import React from "react";
import bottomimg from "public/designbottom.png";

interface TestimonialData {
    headerTitle: string;
    avatarImg?: string;
    companyImg?: string;
    nameText: string;
    professionText: string;
}

interface TestimonialSectionCaseStudyProps {
    testimonialData: TestimonialData;
}

const TestimonialSectionCaseStudy: React.FC<TestimonialSectionCaseStudyProps> = ({ testimonialData }) => {
    return (
        <div className=" py-10">
            <section className="section-testimonial mx-auto rounded-xl lg:pb-20 pb-10 " style={{ background: "#2A4365" }}>
                <div className="keen-slider__slide slider-card relative">
                    <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-4 lg:pt-0 pt-4">
                        <div className="flex flex-col lg:px-20 px-2 space-y-4 w-full h-full lg:space-y-10 lg:py-8">
                            <div className="flex items-center space-x-4 lg:space-x-0 lg:mt-4" style={{ borderRadius: "xl" }}>
                                <img className="h-16 w-16 lg:mt-0" src={testimonialData.avatarImg || ""} alt="owner-image" />
                                <div className="pl-4">
                                    <p className=" text-2xl font-medium text-white">{testimonialData.nameText}</p>
                                    <p className=" text-sm font-normal text-white">{testimonialData.professionText}</p>
                                </div>
                            </div>
                            <img className="absolute  lg:-bottom-16 -bottom-8 lg:right-10 right-5 lg:w-28 w-14 lg:h-20 h-10 " src={bottomimg} alt="small-image" />
                            <h3 className=" lg:text-2xl text-base text-white lg:leading-tight font-medium  lg:text-left">{testimonialData.headerTitle}</h3>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TestimonialSectionCaseStudy;
